export function makeSampleWeatherData() {
  return {
    AbsHumidity: 0,
    AirDensity: 0,
    AvgCorrectedWindDir: 0,
    AvgCorrectedWindSpeed: 0,
    AvgRelativeWindDir: 0,
    AvgRelativeWindSpeed: 0,
    CompassHeading: 0,
    CorrectedGustDirection: 0,
    CorrectedGustSpeed: 0,
    CorrectedWindDir: 0,
    CorrectedWindSpeed: 0.92,
    Dewpoint: 75.2,
    GPSHeading: '',
    GPSLocation: '+32.843528:-080.015936:+0017.50',
    GPSSpeedOverGround: '',
    GPSStatusError: false,
    HeatIndex: 0,
    PositionOfTheSun: 0,
    PrecipIntensity: '',
    RainPresent: false,
    Pressure: 1019.7,
    PressureAtSeaLevel: 0,
    PressureAtStation: 0,
    RelGustDir: 0,
    RelGustSpeed: 0,
    RelHumidity: 84,
    RelWindDir: 241,
    RelWindSpeed: 0.92,
    SensorStatusError: false,
    SolarNoonTime: '',
    SolarRadiation: '0001',
    SunriseTime: '',
    SunsetTime: '',
    SunshineHours: 0,
    Temperature: 80.4,
    TotalPrecip: '00000.000',
    TwilightAstronomical: '',
    TwilightCivil: '',
    TwilightNautical: '',
    WetBulbTemperature: 0,
    WindChill: 0,
    WindSensorError: false,
    XTilt: 0,
    YTilt: 0,
    ZOrientation: '',
  };
}
